import React from 'react';
import { translate } from '../../base/i18n/functions';
import { connect } from 'react-redux';
import { AbstractWelcomePage, _mapStateToProps } from "./AbstractWelcomePage";
import { logoutVianovaUser } from "../functions";
class LogoutPopup extends AbstractWelcomePage {
    render() {
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-content" },
                React.createElement("h1", { className: "testoPopup" }, this.props.t('LogoutPopup.title')),
                React.createElement("h4", { className: "testoPopup" }, this.props.t('LogoutPopup.body')),
                React.createElement("br", null),
                React.createElement("input", { className: "button button--vianova", type: "button", value: this.props.t('LogoutPopup.button').toString(), onClick: () => {
                        logoutVianovaUser();
                    } }))));
    }
}
//export default ErrorPopup;
export default translate(connect(_mapStateToProps)(LogoutPopup));
